import { render, staticRenderFns } from "./GoBuyHead.vue?vue&type=template&id=0bc5d9a2&scoped=true"
import script from "./GoBuyHead.vue?vue&type=script&lang=js"
export * from "./GoBuyHead.vue?vue&type=script&lang=js"
import style0 from "./GoBuyHead.vue?vue&type=style&index=0&id=0bc5d9a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc5d9a2",
  null
  
)

export default component.exports